<template>
  <qx-card-form title="基础信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="serviceName" slot-scope="prop">
        <ChooseServicer
          :isRadio="true"
          :disabled="chooseServicerDisabled"
          :otherSearchData="{
            serviceType: 4,
          }"
          v-model="prop.form.serviceName"
        />
      </section>
      <section slot="plateNumberInfo" slot-scope="prop">
        <ChooseCar
          :isRadio="true"
          :disabled="chooseCarDisabled"
          v-model="prop.form.plateNumberInfo"
          @change="handleChange"
        />
      </section>
      <section slot="location" slot-scope="prop">
        <ChooseAddress
          style="width: 240px"
          :selectType="2"
          v-model="prop.form.location"
          :disabled="chooseAddressDisabled"
        />
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
// import {
//   getFileUrl,
// } from 'api';
import ChooseServicer from 'components/choose/servicer';
import ChooseCar from 'components/choose/car';
import ChooseAddress from 'components/chooseAddress/chooseAddress';
import {
  findAddressName,
} from '@qx/utils';
export default {
  components: {
    ChooseServicer,
    ChooseCar,
    ChooseAddress,
  },
  data () {
    return {
      chooseServicerDisabled: false,
      chooseCarDisabled: false,
      chooseAddressDisabled: false,
      otherFormData: {
        plateNumber: '',
        vehicleCode: '',
        orgId: '',
        opId: '',
        licenceType: '',
        vehicleOwnerShip: '',
        vehicleLength: '',
        vehicleOrigin: '',
        sourceType: '',
        busiCode: '',
        state: '',
        tenantId: '',
        mobilePhone: '',
      },
      baseForm: {
        categoryIdOptions: [],
        form: [
          {
            label: '车牌号码',
            value: 'plateNumberInfo',
            default: {},
            slot: true,
          },
          {
            label: '车辆归属',
            value: 'orgName',
            type: 'input',
            disabled: true,
          },
          {
            label: '违章类型',
            value: 'categoryId',
            type: 'select',
            default: '-1',
            disabled: false,
          },
          {
            label: '违章时间',
            value: 'violationTime',
            type: 'date',
            disabled: false,
            attr:
            {
              type: 'datetime',
              time: '00:00:00',
            },
          },
          {
            label: '违章城市',
            value: 'location',
            slot: true,
          },
          {
            label: '违章地点',
            value: 'violationAddress',
            type: 'input',
            disabled: false,
          },
          {
            label: '违章代码',
            value: 'violationCode',
            type: 'input',
            disabled: false,
          },
          {
            label: '罚金（元）',
            value: 'violationFine',
            type: 'input',
            disabled: false,
          },
          {
            label: '滞纳金（元）',
            value: 'overdueFine',
            type: 'input',
            disabled: false,
          },
          {
            label: '扣分数',
            value: 'violationPoint',
            type: 'input',
            disabled: false,
          },
          {
            label: '成交价',
            value: 'payAmt',
            type: 'input',
            disabled: true,
            hide: true,
          },
          {
            label: '服务商',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商',
            disabled: false,
            slot: true,
            default: {},
          },
          {
            label: '违章行为',
            value: 'violationReason',
            type: 'input',
            disabled: false,
            attr: {
              type: 'textarea',
              limit: 200,
            },
          },
          {
            label: '责任人',
            value: 'personLiable',
            type: 'input',
            disabled: false,
          },
          {
            label: '是否已处理',
            value: 'recordState',
            type: 'select',
            defatult: '-1',
            options: [
              { label: '请选择', value: '-1' },
              { label: '是', value: '2' },
              { label: '否', value: '0' },
            ],
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            attr: {
              type: 'textarea',
              limit: 200,
            },
          },
          {
            label: '上传图片',
            value: 'picList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 5,
            },
            default: [],
            disabled: false,
          },
        ],
        rules: {
          plateNumberInfo: [
            { required: true, message: '请输入车牌号码', trigger: 'blur' },
          ],
          categoryId: [
            { required: true, message: '请选择违章类型', trigger: 'blur' },
          ],
          violationTime: [
            { required: true, message: '请选择违章时间', trigger: 'blur' },
          ],
          violationAddress: [
            { required: true, message: '请输入违章地点', trigger: 'blur' },
          ],
          violationCode: [
            { required: true, message: '请输入违章代码', trigger: 'blur' },
          ],
          violationFine: [
            { required: true, message: '请输入罚金', trigger: 'blur' },
          ],
          violationPoint: [
            { required: true, message: '请输入扣分数', trigger: 'blur' },
            { pattern: /^(([0-9]{1})|1[0|1|2])$/g, message: '请输入0-12之间的数字' },
          ],
          violationReason: [
            { required: true, message: '请输入违章行为', trigger: 'blur' },
          ],
          personLiable: [
            { required: true, message: '请输入责任人', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (options) {
      this.baseForm.categoryIdOptions = options;
    },
    handleChange () {
      const plateNumberInfo = this.$refs.baseForm.getVal('plateNumberInfo');
      this.setFormValFromData(this.otherFormData, plateNumberInfo);
      for (let name in plateNumberInfo) {
        if (name) {
          for (let item of this.baseForm.form) {
            if (item.value === name) {
              this.$refs.baseForm.setVal(name, plateNumberInfo[name] || ' ');
            }
          }
        }
      }
      this.$emit('plateNumberChange', plateNumberInfo);
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
        if (formData.plateNumberInfo) {
          formData.plateNumber = formData.plateNumberInfo.plateNumber;
        }
        if (formData.location && formData.location.length) {
          formData.locationid = formData.location[1];
          formData.provinceId = formData.location[0];
        }
        if (formData.serviceUserId) {
          formData.serviceUserId = formData.serviceName.serviceUserId;
          formData.serviceProvider = formData.serviceName.serviceName;
        }
        if (formData.picList && formData.picList.length) {
          for (let item of formData.picList) {
            item.fileId = item.id;
            item.fileUrl = item.url;
          }
        }
        formData.violationTime = this.formatDate(formData.violationTime, 1);
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        formData = {
          ...formData,
          ...formData.vehicle,
        };
        if (formData.serviceName) {
          formData.serviceProvider = formData.serviceName.serviceName;
          formData.serviceUserId = formData.serviceName.serviceUserId;
        }
        formData.picFileIds = '';
        if (formData.picList && formData.picList.length) {
          let picFileIds = [];
          for (let item of formData.picList) {
            picFileIds.push(item.fileId);
          }
          formData.picFileIds = picFileIds.join();
        }
        if (formData.location && formData.location.length) {
          const names = await findAddressName({
            arr: formData.location,
          });
          formData.provinceName = names[0];
          formData.locationName = names[1];
        }
        delete formData.vehicle;
        delete formData.plateNumberInfo;
        delete formData.serviceName;
        delete formData.picList;
        delete formData.location;
      }
      // console.log('base提交参数', formData);
      return formData;
    },
    // 主要是设置哪些禁用哪些可用
    setFormAttr (data) {
      let hideFormItems = [];
      let hideFormItemsDisabled = false;
      let picListDisabled = false;
      // 这个循环主要是挑出要禁用的项放在 hideFormItems 这个数组里面
      for (let item of this.baseForm.form) {
        if (
          item.value !== 'orgName' &&
          item.value !== 'recordState' &&
          item.value !== 'remark' &&
          item.value !== 'picList') {
          hideFormItems.push(item.value);
        }
      }
      if (this.$route.query.id) {
        // 如果是修改状态才进来这个判断
        // sourceType:1WEB 2APP 3服务商 4费用上报
        if (data.sourceType === 2 || !data.busiCode) {
          hideFormItemsDisabled = false;
          this.chooseServicerDisabled = false;
          this.chooseCarDisabled = false;
          // 上传图片禁用
          picListDisabled = false;
          this.chooseAddressDisabled = false;
        } else {
          // 这个判断条件里，上面挑出的 hideFormItems 数组里面的项禁用，而且选择服务商和选择车也禁用
          hideFormItemsDisabled = true;
          this.chooseServicerDisabled = true;
          this.chooseCarDisabled = true;
          // 上传图片可用
          picListDisabled = false;
          this.chooseAddressDisabled = true;
        }
      } else {
        // 如果是新增状态，所有都不禁用，除了归属部门
        hideFormItemsDisabled = false;
        this.chooseServicerDisabled = false;
        this.chooseCarDisabled = false;
        // 上传图片可用
        picListDisabled = false;
        this.chooseAddressDisabled = false;
      }
      // 设置禁用项
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: hideFormItemsDisabled,
        names: hideFormItems,
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: picListDisabled,
        names: ['picList'],
      });
    },
    // 通过判断 payAmt 这个字段来显示隐藏成交价
    setPayAmtHide (payAmt) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !payAmt,
        names: ['payAmt'],
      });
    },
    async init (data = {}) {

      this.$refs.baseForm.reset();
      this.setFormAttr(data);
      this.setPayAmtHide(data.payAmt);

      if (data.serviceUserId) {
        data.serviceName = {
          serviceName: data.serviceProvider || '',
          serviceUserId: data.serviceUserId,
        };
      }

      if (data.locationid) {
        data.location = [data.provinceId, data.locationid];
      }

      if (data.recordState !== undefined) {
        data.recordState = String(data.recordState);
      }

      if (data.categoryId !== undefined) {
        data.categoryId = String(data.categoryId || '-1');
      }

      if (data.plateNumber) {
        data.plateNumberInfo = {
          plateNumber: data.plateNumber,
        };
      }

      if (data.picList && data.picList.length) {
        for (let item of data.picList) {
          item.id = item.fileId;
          item.url = item.fileUrl;
        }
      }

      this.$refs.baseForm.setVal(data);
      this.setFormValFromData(this.otherFormData, data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
